module.exports = __webpack_public_path__ + "static/img/menage6.c44a359e.png";